import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalStat, UsageStat } from '@shared/index';
import dayjs from 'dayjs';
import { firstValueFrom } from 'rxjs';
import { Month } from './statistics-month-selector/statistics-month-selector.component';

@Injectable({
  providedIn: 'root'
})
export class StatisticService {
  public debugLog: GlobalStat[] = [];

  constructor(private http: HttpClient) { }

  public async getStatistics(botId: string): Promise<UsageStat[]> {
    return await firstValueFrom(this.http.get<UsageStat[]>("/api/toolbox/stats/get/" + botId));
  }

  public async reportHeygenStat(botId: string, duration_ms: number) {
    return await firstValueFrom(this.http.post<UsageStat[]>(`/api/toolbox/heygen/reportusage/${botId}`, { duration_ms }));
  }

  public getMonth(month: Month): string {
    return dayjs().set("month", month - 1).format('MMMM');
  }
}